import { render } from "./CobraBenefits.vue?vue&type=template&id=6ee06568&scoped=true&ts=true"
import script from "./CobraBenefits.vue?vue&type=script&lang=ts"
export * from "./CobraBenefits.vue?vue&type=script&lang=ts"

import "./CobraBenefits.vue?vue&type=style&index=0&id=6ee06568&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee06568"]])

export default __exports__